export default __webpack_public_path__ + "static/media/featDesktop.c3888ee5.png";